export var Size;
(function (Size) {
    Size[Size["default"] = 0] = "default";
    Size[Size["sm"] = 640] = "sm";
    Size[Size["md"] = 768] = "md";
    Size[Size["lg"] = 1024] = "lg";
    Size[Size["xl"] = 1280] = "xl";
    Size[Size["2xl"] = 1536] = "2xl";
})(Size || (Size = {}));
export const sizeFor = (viewportWidth, size = null) => {
    if (size === null) {
        return `${viewportWidth}vw`;
    }
    const resolvedSize = Number(Size[size]);
    return `(min-width: ${resolvedSize}px) ${viewportWidth}vw`;
};
